<template>
  <!-- 3D动画数据入库 -->
  <div class="layout">
    <div class="menu">
      <Menu topIndex="3"></Menu>
    </div>
    <div class="leftSide">
      <LeftSideBar current="toStorage" leftIndex="2"></LeftSideBar>
    </div>
    <div id="deptContentBox" class="base-content">
      <div>
        <el-button
          type="text"
          size="small"
          icon="el-icon-plus"
          @click="createScource()"
          >新建</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-download"
          @click="transSource()"
          >导入</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          @click="stopPre()"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="checkLog()"
          >删除</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-document-copy"
          @click="bulkImport()"
          >批量导入</el-button
        >
      </div>
      <div id="searchBox">
        <el-form label-width="80px">
          <el-form-item label="标题">
            <el-input placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="外链资源">
            <el-input placeholder="请输入外链资源"></el-input>
          </el-form-item>
          <el-form-item label-width="0px">
            <el-button type="primary" size="mini" icon="el-icon-search"
              >查询</el-button
            >
            <el-button type="primary" size="mini" icon="el-icon-delete"
              >重置
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="tableData"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        style="width: 100%"
        class="maintable"
        border
        :header-cell-style="{ background: '#f8f8f8' }"
      >
        <el-table-column
          type="selection"
          min-width="55"
          align="center"
        ></el-table-column>
        <el-table-column type="index" min-width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          show-overflow-tooltip
          min-width="80"
          label="封面图"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="address"
          min-width="80"
          label="标题"
          align="center"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="链接"
          min-width="70px"
          align="center"
        >
          <template>
            <span>是</span>
            <span>否</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="外联资源"
          min-width="70px"
          align="center"
        >
          <template>
            <span>是</span>
            <span>否</span>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="添加人" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="添加时间" align="center">
        </el-table-column>
      </el-table>
      <!-- 新建弹窗 -->
      <el-dialog
        title="新建资源"
        :visible.sync="createDialog"
        width="600px"
        class="sourceUpload"
      >
        <div>
          <el-form>
            <el-form-item label="封面" label-width="60px">
              <el-upload action="#" list-type="picture-card">
                <i slot="default" class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="标题" label-width="60px">
              <el-input></el-input>
            </el-form-item>
            <el-form-item label="URL" label-width="60px">
              <el-input></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="createDialog = false">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 批量导入弹窗 -->
      <el-dialog
        title="批量导入"
        :visible.sync="bulkImportDialog"
        width="600px"
      >
        <el-form>
          <el-form-item label="文件：" label-width="60px">
            <el-upload>
              <el-button slot="trigger" size="small" type="primary"
                >选取文件</el-button
              >
              <el-button style="margin-left: 10px" size="small" type="success"
                >上传到服务器</el-button
              >
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="bulkImportDialog = false">关 闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Menu from "../../menu/menu.vue";
import LeftSideBar from "../../menu/leftSideBar.vue";
export default {
  components: {
    Menu,
    LeftSideBar,
  },
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "上海市普陀区金沙江路",
        },
      ],
      createDialog: false,
      bulkImportDialog: false,
    };
  },
  methods: {
    createScource() {
      this.createDialog = true;
    },
    bulkImport() {
      this.bulkImportDialog = true;
    },
  },
};
</script>

<style>
</style>